module.exports = __webpack_public_path__ + "media/street-food.9087241c.mp4";